import { useCallback, useMemo } from 'react';
import { useEntitlements } from '../../lib/useEntitlements';
import { getInterviewLanguagePolicy, type FeatureKey } from '../../lib/entitlements';

/** Keep builder and overview gating aligned while organization access resolves. */
export function useConversationSettingsAccess() {
  const { can: rawCan, loading, tier } = useEntitlements();
  const can = useCallback((feature: FeatureKey) => loading || rawCan(feature), [loading, rawCan]);
  const languagePolicy = useMemo(() => {
    if (loading) return { allowLanguageChoice: true, enforcedLanguage: null };
    const policy = getInterviewLanguagePolicy(tier);
    return policy.allowLanguageChoice && can('multi_language_interviews')
      ? policy
      : { allowLanguageChoice: false, enforcedLanguage: policy.enforcedLanguage ?? 'en-US' };
  }, [loading, tier, can]);
  return { can, languagePolicy };
}
